<script>
import CreateView from '../base/CreateView.vue'
import FormInput from '../form/form-input.vue'

export default {
  components: {
    CreateView,
    FormInput,
  },
}
</script>
<template>
  <create-view store="company" update-route="CompanyUpdate" v-slot:default="slotProps">
    <form-input :store="slotProps.store" prop-name="name" class="col-3"></form-input>
    <form-input :store="slotProps.store" prop-name="invoicePattern" class="col-3"></form-input>
    <form-input :store="slotProps.store" prop-name="customerPattern" class="col-3"></form-input>
    <form-input :store="slotProps.store" prop-name="projectPattern" class="col-3"></form-input>
  </create-view>
</template>
